import { type EnterpriseProfileType } from "@mg/schemas/src/commons";
import { useMutation, useQuery } from "@tanstack/react-query";

import {
  archiveUser,
  getArchivedUsers,
  archiveMeaningfulGigsUser,
  getUsers,
  getMeaningfulGigsUsers,
  inviteUser,
  addUserToEnterprise,
  updateCurrentUser,
  unarchiveUser,
  updateUserRole,
  resendInvite,
} from "../../services/users";

export function useGetUsers(roles?: EnterpriseProfileType[]) {
  const query = useQuery({
    queryKey: ["retrieve-users", ...(roles ?? [])],
    queryFn: () => getUsers(roles),
  });

  return query;
}

export function useGetArchivedUsers() {
  const query = useQuery({
    queryKey: ["retrieve-archived-users"],
    queryFn: getArchivedUsers,
  });

  return query;
}

export function useGetMeaningfulGigsUsers() {
  const query = useQuery({
    queryKey: ["retrieve-meaningful-gigs-users"],
    queryFn: () => getMeaningfulGigsUsers(),
  });

  return query;
}

export function useInviteUser() {
  const mutation = useMutation({
    mutationFn: inviteUser,
  });

  return mutation;
}

export function useAddUserToEnterprise() {
  const mutation = useMutation({
    mutationFn: addUserToEnterprise,
  });

  return mutation;
}

export function useUpdateCurrentUser() {
  const mutation = useMutation({
    mutationKey: ["update-current-user"],
    mutationFn: updateCurrentUser,
  });

  return mutation;
}

export function useArchiveUser() {
  const mutation = useMutation({
    mutationKey: ["archive-user"],
    mutationFn: archiveUser,
  });

  return mutation;
}

export function useUnarchiveUser() {
  const mutation = useMutation({
    mutationKey: ["unarchive-user"],
    mutationFn: unarchiveUser,
  });

  return mutation;
}

export function useArchiveMeaningfulGigsUser() {
  const mutation = useMutation({
    mutationKey: ["archive-meaningful-gigs-user"],
    mutationFn: archiveMeaningfulGigsUser,
  });

  return mutation;
}

export function useUserRoleMutation() {
  return useMutation({
    mutationKey: ["users", "role"],
    mutationFn: updateUserRole,
  });
}

export function useResendInvite() {
  return useMutation({
    mutationKey: ["resend-invite"],
    mutationFn: resendInvite,
  });
}
